import script from "./FormSecureUpload.vue?vue&type=script&setup=true&lang=js"
export * from "./FormSecureUpload.vue?vue&type=script&setup=true&lang=js"

import "./FormSecureUpload.vue?vue&type=style&index=0&id=1e86beba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e86beba"]])

export default __exports__